// initial state
const state = {
  all: [],
  count: 0,
  toolsLog: 'Loading...',
  emailBounceOverview: {
    total_recent: 0,
    hard_bounces: 0,
    deferred: 0,
    rate_limited: 0,
    alarmable_recent: 0,
    non_alarm_recent: 0,
    blacklist_recent: 0,
    threshold: 10,
    deferred_threshold: 5,
    window_minutes: 15,
    log_read_limit: 5000,
    recent_limit: 250,
    alarm_active: false,
    active_alerts: [],
    by_reason: {},
    by_provider: [],
    recent: []
  },
  emailRoutingRules: {
    default: 'namecheap',
    rules: [],
    updated_at: null
  }
}

// getters
const getters = {
  Auditlog: state => state.all,
  LogCount: state => state.count,
  ToolsLog: state => state.toolsLog,
  EmailBounceOverview: state => state.emailBounceOverview,
  EmailRoutingRules: state => state.emailRoutingRules,
}

// actions
const actions = {
  getAuditlog ({ commit }, trades) {
    commit('setAuditlog', trades.data)
  },
  getToolslog ({ commit }, trades) {
    commit('setToolslog', trades.data)
  },
  getEmailBounceOverview ({ commit }, payload) {
    commit('setEmailBounceOverview', payload.data)
  },
  getEmailRoutingRules ({ commit }, payload) {
    commit('setEmailRoutingRules', payload.data)
  },
  ClearLog ({ commit }, trades) {
    commit('clearToolslog')
  },
  clearAuditlog ({ commit }) {
    commit('clearAuditlog')
  }
}

// mutations
const mutations = {
  setAuditlog (state, log) {
    state.all = log.entries
    if (log.count > 0) {
      state.count = log.count
    }
  },
  clearAuditlog (state) {
    state.all = []
  },
  clearToolslog (state) {
    state.toolsLog = 'Loading...'
  },
  setToolslog (state, log) {
    state.toolsLog = log
  },
  setEmailBounceOverview (state, overview) {
    state.emailBounceOverview = overview
  },
  setEmailRoutingRules (state, payload) {
    state.emailRoutingRules = payload
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
